import { useEffect } from 'react'
import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router'
import { AlertTriangle, Home, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { reportRollbarError } from '@/services/core/rollbar'

export function ErrorPage() {
  const error = useRouteError()
  const navigate = useNavigate()

  useEffect(() => {
    if (isRouteErrorResponse(error)) {
      if (![401, 403, 404, 422].includes(error.status)) {
        reportRollbarError(new Error(`${error.status} ${error.statusText}`), {
          status: error.status,
          data: error.data,
        })
      }
    } else {
      reportRollbarError(error)
    }
  }, [error])

  let title = 'Something went wrong'
  let message = 'An unexpected error occurred.'

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`
    message = error.data?.message ?? message
  } else if (error instanceof Error) {
    message = error.message
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-(--ad-bg)">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <AlertTriangle className="size-12 text-(--ad-warning)" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-(--ad-text)">{title}</h1>
          <p className="text-sm text-(--ad-text-muted)">{message}</p>
        </div>
        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={() => window.location.reload()}>
            <RefreshCw className="size-4" />
            Reload
          </Button>
          <Button onClick={() => navigate('/', { replace: true })}>
            <Home className="size-4" />
            Go home
          </Button>
        </div>
      </div>
    </div>
  )
}
